<template>
  <div class="usual-btns">
    <!-- <el-button type="link" @click="getUsual" :disabled="disabled">填充常用规格</el-button> -->
    <el-button type="link" icon="el-icon-edit" :disabled="disabled" @click="editUsual">填充常用规格</el-button>
    <EditUsualDialog :disabled="disabled" ref="editDialog" />
  </div>
</template>

<script>
import EditUsualDialog from './EditUsualDialog.vue';

// 常用规格组件
export default {
  components: {
    EditUsualDialog,
  },
  props: {
    spName: {
      type: String,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    // 编辑常用规格
    editUsual() {
      this.$refs.editDialog.method_open({
        spcificationName: this.spName,
        usualFn: ({ specificationValue }) => {
          this.$emit('usual', specificationValue ? specificationValue.split(',') : []);
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.usual-btns {
  display: inline-block;
}
</style>